<template>
  <div class="flex-center-center">
    <QRCodeVue
      :value="url"
      size="127"
      class="flex-center-center"
      :data-test-id="qrTestId"
    />
    <div class="ml-2">
      <QRDownload
        id="dashboard_mainSelected_button_share_qrSvg"
        :url="url"
        type="svg"
        class="btn btn-green btn-block mb-1"
      >
        SVG
      </QRDownload>
      <QRDownload
        id="dashboard_mainSelected_button_share_qrPng"
        :url="url"
        type="png"
        class="btn btn-green btn-block mb-1"
      >
        PNG
      </QRDownload>
      <QRDownload
        id="dashboard_mainSelected_button_share_qrPng1200"
        :url="url"
        type="png"
        size="1200"
        class="btn btn-green btn-block mb-0"
      >
        PNG 1200
      </QRDownload>
    </div>
  </div>
</template>

<script>
import QRCodeVue from "qrcode.vue";
import QRDownload from "@Components/sharing/QRDownload.vue";

export default {
  name: "QR",

  components: { QRCodeVue, QRDownload },

  props: {
    qrTestId: {
      type: String,
      required: true,
    },

    url: {
      type: String,
      default: "",
    },
  },
};
</script>
